import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import TraitsPerThematicList from 'components/business/thematic-packages/thematic-package-details/TraitsPerThematicList';
import ThematicPackageDetails from '../components/business/thematic-packages/ThematicPackageDetails';
import ThematicPackages from '../components/business/ThematicPackages';
import ThematicPackageReportPreview from '../components/business/thematic-packages/ThematicPackageReportPreview';

export const ThematicPackagePageCtx = React.createContext({});

function ThematicPackagePageProvider(props) {
  const [ search, setSearch ] = useState('');
  const [ thematicPackage, setThematicPackage ] = useState(undefined);

  const ctx = {
    search,
    setSearch,
    thematicPackage,
    setThematicPackage,
  };

  return (
    <ThematicPackagePageCtx.Provider value={ ctx }>
      {props.children}
    </ThematicPackagePageCtx.Provider>
  );
}

function ThematicPage() {
  const location = useLocation();

  const { search } = location;
  const params = new URLSearchParams(search);
  const id = params.get('id');
  const pid = params.get('pid');

  return (
    <ThematicPackagePageProvider>
      {
        !id ? <ThematicPackages /> : (
          !pid ? <ThematicPackageDetails id={ id } /> : (
            ('Traits' === pid) ? <TraitsPerThematicList id={ id } />
              : ('Report' === pid) ? <ThematicPackageReportPreview id={ id } /> : null
          )
        )
      }
    </ThematicPackagePageProvider>
  );
}

export default ThematicPage;
